import React from 'react';
import FormContents from 'components/atoms/Form/FormContents';
import LoginInputForm from './LoginInputForm';

const LoginForm: React.FC = () => (
  <FormContents>
    <LoginInputForm />
  </FormContents>
);

export default LoginForm;
